define(function (require) {
	const Marionette = require('backbone.marionette');
	const tpl = require('./templates/t_cpv_details.hbs');
	const itemView = require('./v_itv_detail');

	return Marionette.CompositeView.extend({
		initialize: function (options) {
			this.config = options.config;
			this.useDetailCollection = options.useDetailCollection;
			this.initialEnabled = options.initialEnabled;
			this.toggleEnabled = options.toggleEnabled;
			this.ineffectiveApplicant = options.ineffectiveApplicant;
			this.aggregateModel = options.aggregateModel;
			this.aggregateModelDetailPropertyId = options.aggregateModelDetailPropertyId;
			this.loadParentHansenModel = options.loadParentHansenModel;
			this.defaultExpanded = options.defaultExpanded;
		},
		childViewOptions: function () {
			return {
				config: this.config,
				isAdd: false,
				initialEnabled: this.initialEnabled,
				toggleEnabled: this.toggleEnabled,
				ineffectiveApplicant: this.ineffectiveApplicant,
				useDetailCollection: this.useDetailCollection,
				aggregateModel: this.aggregateModel,
				aggregateModelDetailPropertyId: this.aggregateModelDetailPropertyId,
				loadParentHansenModel:this.loadParentHansenModel,
				defaultExpanded: this.defaultExpanded
			};
		},
		template: tpl,
		childViewContainer: function () {
			return ".list-table"
		},
		childView: itemView,
		templateHelpers: function () {
			return {};
		}
	});
});
